/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ScanStatus = {
  /**
   * UUID of the scan
   */
  id: string;
  /**
   * Status of the scanned file. Will be one of the below states.
   *
   * - S3UrlGenerated - S3 URL has been generated but files haven't been uploaded
   * - FileUploaded - File has been uploaded but waiting to be canned
   * - Scanning - System is currently scanning the file
   *
   * *Note*: Pending on how long the file is in the queue for it may not flow through all three states above. If it's scanned fairly instantly then it will flow to a completed status listed below.
   *
   * Below three status' will be set with the result of the scanned operation
   * - Success - completed no virus, no errors
   * - Flagged - flagged a virus. File is automatically deleted from S3 and no longer available
   * - Error - Unknown state
   *
   */
  status: ScanStatus.status;
  /**
   * Will be null if the virus file is not in a successful state. Once the file has been successfully scanned,
   * a presigned S3 URL to download the original scan file will be available.
   *
   */
  downloadUrl?: string | null;
};

export namespace ScanStatus {
  /**
   * Status of the scanned file. Will be one of the below states.
   *
   * - S3UrlGenerated - S3 URL has been generated but files haven't been uploaded
   * - FileUploaded - File has been uploaded but waiting to be canned
   * - Scanning - System is currently scanning the file
   *
   * *Note*: Pending on how long the file is in the queue for it may not flow through all three states above. If it's scanned fairly instantly then it will flow to a completed status listed below.
   *
   * Below three status' will be set with the result of the scanned operation
   * - Success - completed no virus, no errors
   * - Flagged - flagged a virus. File is automatically deleted from S3 and no longer available
   * - Error - Unknown state
   *
   */
  export enum status {
    S3URL_GENERATED = 'S3UrlGenerated',
    FILE_UPLOADED = 'FileUploaded',
    SCANNING = 'Scanning',
    SUCCESS = 'Success',
    FLAGGED = 'Flagged',
    ERROR = 'Error',
  }
}
